// Translations for the application (English only)
export type Language = "en";

export const translations: Record<Language, Record<string, string>> = {
  en: {
    // Header
    "nav.home": "Home",
    "nav.about": "About Us",
    "nav.international": "International",
    "nav.faqs": "FAQs",
    "nav.blogs": "Blogs",
    "nav.contact": "Contact Us",

    // Hero Section
    "hero.save": "Save 60% On Your",
    "hero.space": "Space Today.",
    "hero.feature1": "Walking distance to terminal",
    "hero.feature2": "Monitored Car Parks",
    "hero.feature3": "24/7 Live Support",

    // Booking Form
    "booking.entryDate": "Entry Date",
    "booking.entryTime": "Entry Time",
    "booking.exitDate": "Exit Date",
    "booking.exitTime": "Exit Time",
    "booking.promoCode": "Promo Code",
    "booking.enterPromo": "Enter promo code",
    "booking.selectEntryDate": "Select entry date",
    "booking.selectExitDate": "Select exit date",
    "booking.termsText": "By clicking Find Parking, you agree to our",
    "booking.termsLink": "terms & conditions",
    "booking.findParking": "Find Parking",
    "booking.dropoff": "Drop-off",
    "booking.pickup": "Pick-up",
    "booking.search": "Search",
    "booking.selectDate": "Select date",
    "booking.selectTime": "Select time",

    // Partners
    "partners.title": "Our Trusted Partners",

    // Network
    "network.view": "View our network →",

    // Testimonials
    "testimonials.title": "What Our Customers Say",
    "testimonials.viewMore": "View More",
    "testimonials.frequentFlyer": "Frequent Flyer",
    "testimonials.businessTraveller": "Business Traveller",
    "testimonials.businessOwner": "Business Owner",
    "testimonials.holidayTraveller": "Holiday Traveller",
    "testimonials.regularCustomer": "Regular Customer",
    "testimonials.firstTimeUser": "First Time User",
    "testimonials.familyVacation": "Family Vacation",
    "testimonials.weekendGetaway": "Weekend Getaway",
    "testimonials.businessTrip": "Business Trip",

    // How It Works
    "how.step1.title": "Select Dates",
    "how.step1.desc": "Start In A Blink Of An Eye",
    "how.step2.title": "Choose Parking Product",
    "how.step2.desc": "Choose Parking Product That Suits Your Need & Budget",
    "how.step3.title": "Easy to Book",
    "how.step3.desc": "Just Confirm Details & Pay With An Easy & Fast Booking Process",

    // Why Choose Us
    "why.title": "Why Choose Us?",
    "why.subtitle":
      "Don't burden yourself with the stress and inconvenience of finding parking on the day, book in advance to ensure you will never pay more than if you park without a reservation and have a peaceful start to your travels.",
    "why.feature1": "Guaranteed Parking Availability",
    "why.feature2": "24/7 Customer Support",
    "why.feature3": "Free Shuttle Bus 24/7",
    "why.feature4": "Luggage Assistance",
    "why.feature5": "Patrolled Car Parks",
    "why.feature6": "Friendly & Professional Staff",
    "why.feature7": "Choice of Service",
    "why.feature8": "Collected and Dropped Back to the Boot",
    "why.stat1": "Years of Service",
    "why.stat2": "Happy Customers",
    "why.stat3": "Cars Parked Daily",
    "why.stat4": "Industry Awards",

    // Services
    "services.title": "Our Services",
    "services.subtitle": "Global Operations & Services",
    "services.meetGreet.title": "Meet & Greet",
    "services.meetGreet.desc":
      "The fastest and easiest way to park at the airport is to drive straight to the terminal entrance, hand over your car to the driver, grab your luggage, and you're off. When you return, just give the driver a call, and they'll bring your car to meet you at the terminal entrance.",
    "services.parkRide.title": "Park & Ride",
    "services.parkRide.desc":
      "The most budget-friendly parking option, typically involving a 5 to 10 minute transfer via shuttle. Most Park & Ride facilities are highly secure and provide personalized customer service. Shuttles usually operate frequently and are available on demand for your convenience.",

    // About Section
    "about.title": "About Go Airpot Parking",
    "about.welcome": "Welcome to Go Airport Parking",
    "about.desc1":
      ", the UK’s reliable airport parking platform. For over a decade, we've helped thousands of travelers find dependable, affordable parking at major airports across the country. Our reputation is built on a commitment to excellent service and outstanding value.",
    "about.desc2": "Now, we're bringing our expertise to",
    "about.desc2b":
      ". Our dedicated local team is focused on delivering seamless, convenient, and tailored service that offers all the quality you expect from the Go Airport Parking brand.",
    "about.desc2c": "brand.",
    "about.badge1": "Monitored Parking",
    "about.badge2": "Friendly & Trained Staff",
    "about.badge3": "Free Shuttle Transfers",
    "about.badge4": "Best Price Guarantee",
    "about.brand.title": "Go Airport Parking — A Trusted UK Brand",
    "about.brand.p1": "For over a decade,",
    "about.brand.p1b":
      "Go Airport Parking has been a trusted name in airport parking services across the UK. Our mission is simple: to make your journey smoother by offering a wide range of secure, reliable, and affordable airport parking options. With our easy-to-use online booking platform and a network of professional parking operators, we ensure outstanding value and peace of mind for every traveler.",
    "about.brand.p2":
      "Discover our trusted airport parking solutions at the United Kingdom's busiest airports, including Heathrow, Gatwick, Manchester, and more. We've built our reputation on providing safe, convenient, and cost-effective parking, so you can travel with confidence knowing your car is in good hands. Whether you need short stay, long stay, or meet-and-greet airport parking,",
    "about.brand.p2b": "Go Airport Parking is here to make your journey stress-free.",

    // FAQ Section
    "faq.title": "Frequently Asked Questions",
    "faq.subtitle": "Have questions about our services? Here are some of the most common queries from our customers.",
    "faq.q1": "How do I book parking at",
    "faq.a1":
      "Simply use our online booking form on this page. Select your entry and exit dates, choose your preferred parking option, and complete your reservation in just a few minutes.",
    "faq.q2": "What parking options are available?",
    "faq.a2":
      "We offer Meet & Greet service where you drop your car at the terminal, and Park & Ride where you park in our secure lot and take a free shuttle to the terminal",
    "faq.q3": "Is my car secure while parked?",
    "faq.a3":
      "Yes, all our car parks are fully secured with 24/7 CCTV monitoring, regular patrols, and secure fencing. Your vehicle is in safe hands with us.",
    "faq.q4": "Can I modify or cancel my booking?",
    "faq.a4":
      "Yes, you can modify or cancel your booking Contact our 24x7 support team and they will assist you to cancel or modify your booking.",
    "faq.q5": "Can I amend or cancel my booking?",
    "faq.a5":
      "Yes. Amend or cancel using the link in your confirmation email. Refunds apply 24+ hrs before drop-off (minus admin fee).",
    "faq.q6": "How do I pay for my booking?",
    "faq.a6": "We accept all major debit and credit cards. Payments are processed securely online.",
    "faq.q7": "Are my payment details secure?",
    "faq.a7": "Yes, all transactions are encrypted and processed via secure gateways.",
    "faq.q8": "What happens if my flight is delayed?",
    "faq.a8": "We track flights. Pick-up time is adjusted at no extra cost.",
    "faq.q9": "How early should I arrive before my flight?",
    "faq.a9": "Arrive at least 2–3 hours before your flight to allow transfer time.",
    "faq.q10": "Do you provide shuttle transfers?",
    "faq.a10": "Yes, free shuttle transfers to and from terminals are included.",
    "faq.q11": "What if I arrive late to drop off my car?",
    "faq.a11": "Call us as soon as possible. We’ll try to accommodate but late arrivals may cause delays or charges.",
    "faq.q12": "Can I add extras like car wash or VIP lounge?",
    "faq.a12": "VIP lounge, car wash, and EV charging can be added during booking.",
    "faq.q13": "Are EV charging points available?",
    "faq.a13": "Yes, EV charging is available on request.",
    "faq.q14": "Do you offer loyalty discounts?",
    "faq.a14": "Yes, regular customers may qualify for discounts. Contact support for details.",
    "faq.still": "Still have a question?",
    "faq.agents": "Our Agents Will Be With You In Seconds",
    "faq.call": "Call Us Now",
    "faq.more": "More FAQs",

    // Footer
    "footer.desc": "provides reliable, affordable, and convenient parking solutions, trusted by thousands every year.",
    "footer.useful": "Useful Links",
    "footer.contact": "Contact",
    "footer.rights": "All rights reserved.",
    "footer.whyChoose": "Why Choose Us",
    "footer.services": "Services",
    "footer.about": "About",
    "footer.faqs": "FAQs",
    "footer.testimonials": "Testimonials",
    "footer.terms": "Terms & Conditions",
    "footer.privacy": "Privacy Policy",
    "footer.contactUs": "Contact Us",

    // Select Parking Page
    "selectParking.title": "Choose Your Parking",
    "selectParking.loading": "Loading parking options...",
    "selectParking.noOptions": "No parking options available for the selected dates.",
    "selectParking.all": "All",
    "selectParking.meetGreet": "Meet & Greet",
    "selectParking.parkRide": "Park & Ride",
    "selectParking.sortLowHigh": "Price: Low to High",
    "selectParking.sortHighLow": "Price: High to Low",
    "selectParking.bookNow": "Book Now",
    "selectParking.moreInfo": "More Info",

    // Booking Profile Page
    "profile.yourDetails": "Your Details",
    "profile.carDetails": "Car Details",
    "profile.flightDetails": "Flight Details",
    "profile.firstName": "First Name",
    "profile.surname": "Surname",
    "profile.email": "Email",
    "profile.contactNumber": "Contact Number",
    "profile.carRegistration": "Car Registration",
    "profile.carManufacturer": "Car Manufacturer",
    "profile.carModel": "Car Model",
    "profile.carColour": "Car Colour",
    "profile.departureTerminal": "Departure Terminal",
    "profile.returnTerminal": "Return Terminal",
    "profile.departureFlightNumber": "Departure Flight Number",
    "profile.returnFlightNumber": "Return Flight Number",
    "profile.selectTerminal": "Select terminal",
    "profile.bookNow": "Book Now",
    "profile.bookingSummary": "Booking Summary",
    "profile.parkingType": "Parking Type",
    "profile.entry": "Entry",
    "profile.exit": "Exit",
    "profile.price": "Price",
    "profile.bookingFee": "Booking Fee",
    "profile.total": "Total",
    "profile.refNumber": "Reference Number",
    "profile.timeLeft": "Time Left",
    "profile.required": "is required",
    "profile.validEmail": "Valid email is required",
    "profile.fillPersonal": "Please fill in all required personal details",
    "profile.fillCar": "Please fill in all required car details",
    "profile.fillAll": "Please fill in all required personal and car details",

    // Booking Confirm Page
    "confirm.title": "Confirm Your Booking",
    "confirm.bookingDetails": "Booking Details",
    "confirm.customerDetails": "Customer Details",
    "confirm.vehicleDetails": "Vehicle Details",
    "confirm.payNow": "Pay Now",
    "confirm.securePayment": "Secure Payment",
    "confirm.paymentInfo": "You will be redirected to a secure payment page",
    "confirm.readyToPay": "Ready to Pay",
    "confirm.clickToPay": "Click below to proceed to the secure payment page",
    "confirm.proceedToPayment": "Proceed to Payment",
    "confirm.redirecting": "Redirecting...",
    "confirm.redirectingToPayment": "Redirecting to Payment...",
    "confirm.verifyingPayment": "Verifying Payment...",
    "confirm.pleaseWait": "Please wait while we verify your payment",
    "confirm.preparingPayment": "Preparing secure payment...",
    "confirm.preparing": "Preparing...",
    "confirm.continueToThankYou": "Continue to Thank You",
    "confirm.transactionSuccessful": "Transaction Successful!",
    "confirm.redirectingThankYou": "Redirecting to Thank You page...",
    "confirm.bookingSummary": "Booking Summary",
    "confirm.bookingRef": "Booking Ref",
    "confirm.passenger": "Passenger",
    "confirm.email": "Email",
    "confirm.phone": "Phone",
    "confirm.car": "Car",
    "confirm.departureFlight": "Departure Flight",
    "confirm.returnFlight": "Return Flight",
    "confirm.bookingFee": "Booking Fee",
    "confirm.paymentDetails": "Payment Details",
    "confirm.paymentMethods": "Payment Methods",
    "confirm.mayTake": "This may take up to 30 seconds...",
    "confirm.processing": "Processing...",
    "confirm.pay": "Pay",
    "confirm.paymentCompletedQ": "Payment completed?",
    "confirm.paymentCompletedDesc": "If you've finished payment, continue to complete your booking.",
    "confirm.sendConfirmationTo": "We'll send confirmation to {email}.",
    "confirm.yourEmail": "your email",
    "confirm.secureBadge": "All payments are encrypted & 100% secure",

    // About Us Page
    "aboutPage.title": "About Us",
    "aboutPage.subtitle": "Your trusted partner for",
    "aboutPage.parking": "parking",
    "aboutPage.missionTitle": "Mission Statement",
    "aboutPage.missionText":
      "When parking at {airport}, make sure to select the correct {brand} option and give yourself plenty of time ensuring you enjoy a relaxing and stress-free start to your journey.",
    "aboutPage.journeyTitle": "Our Journey",
    "aboutPage.trustTitle": "Why Trust Us",
    "aboutPage.coreValues": "Core Values",
    "aboutPage.customerService": "Customer Service",
    "aboutPage.cost": "Cost",
    "aboutPage.convenience": "Convenience",
    "aboutPage.trustedBrand": "Trusted Brand",
    "aboutPage.localExpertise": "Local Expertise",
    "aboutPage.customerFirst": "Customer First",
    "aboutPage.nationwideExperience": "Nationwide Experience",
    "aboutPage.tailoredService": "Tailored Service",
    "aboutPage.transparentPricing": "Transparent Pricing",
    "aboutPage.qualityExtras": "Quality & Extras",
    "aboutPage.missionHistory": "Mission & History",
    "aboutPage.whyChoose": "Why Choose Us?",
    "aboutPage.bookNow": "Book Now",
    "aboutPage.timeline.2010": "Founded with a mission to make airport parking simple & affordable.",
    "aboutPage.timeline.2011":
      "Started with individual websites dedicated to different airports, building trust locally.",
    "aboutPage.timeline.2015": "Expanded nationwide across major UK airports with individual platforms.",
    "aboutPage.timeline.2020": "Celebrated 1 million travelers served across the UK.",
    "aboutPage.timeline.2023":
      "Brought everything together under the {brand} umbrella — a comparison platform uniting all sites.",
    "aboutPage.timeline.2024": "Upgraded facilities & introduced premium valet + extras.",
    "aboutPage.timeline.2025": "Launched {airport} services with territorial expertise.",
    "aboutPage.missionHistory.p1":
      "Since our beginnings as part of Go Airport Parking, our mission has been clear: make parking at airports simple, secure, and stress-free. We believe that the journey begins not when you board the plane but from the moment you leave your home.",
    "aboutPage.missionHistory.p2":
      "Our {airport} site builds on that legacy. We've selected convenient locations, invested in quality facilities, and trained our staff to uphold high standards—all so that our customers get the best possible experience under our trusted brand {brand}.",

    // About Us (dynamic descriptions)
    "aboutPage.trust.trustedBrandDesc":
      "Part of Go Airport Parking, a nationwide leader with years of experience in secure airport parking.",
    "aboutPage.trust.localExpertiseDesc":
      "Our {airport} team ensures your journey starts and ends smoothly, right from the airport gates.",
    "aboutPage.trust.customerFirstDesc":
      "Committed to delivering excellent service, transparent pricing, and reliable extras for every traveler.",
    "aboutPage.why.nationwideExperienceDesc":
      "Backed by years of experience across the UK, we bring stability, trust, and proven operations.",
    "aboutPage.why.tailoredServiceDesc":
      "Focused on the needs of {airport} travelers: local staff, optimized logistics, and extras that matter.",
    "aboutPage.why.transparentPricingDesc":
      "Clear, upfront pricing, no hidden fees. You'll always see what you pay for.",
    "aboutPage.why.qualityExtrasDesc":
      "Valet, lounge access, car care, and more—choose what adds real value to your trip.",

    // Contact Page
    "contact.title": "Contact Us",
    "contact.subtitle": "Get in touch with us",
    "contact.name": "Your Name",
    "contact.email": "Your Email",
    "contact.subject": "Subject",
    "contact.message": "Your Message",
    "contact.send": "Send Message",
    "contact.sending": "Sending...",
    "contact.success": "Message sent successfully!",
    "contact.error": "Failed to send message. Please try again.",
    "contact.phone": "Phone",
    "contact.emailLabel": "Email",
    "contact.address": "Address",
    "contact.sendMessageTitle": "Send Us a Message",
    "contact.enquiryQuestion": "What is your enquiry concerning?",
    "contact.enquiryTypePlaceholder": "Enquiry Type",
    "contact.enquiry.booking": "Booking Enquiry",
    "contact.enquiry.general": "General Enquiry",
    "contact.enquiry.complaint": "Complaint",
    "contact.enquiry.feedback": "Feedback",
    "contact.enquiry.partnership": "Partnership",
    "contact.titlePlaceholder": "Title",
    "contact.title.mr": "Mr",
    "contact.title.mrs": "Mrs",
    "contact.title.ms": "Ms",
    "contact.title.dr": "Dr",
    "contact.firstName": "First Name",
    "contact.surname": "Surname",
    "contact.contactNumber": "Contact Number",
    "contact.validationRequired": "Please fill in all required fields.",
    "contact.successDesc": "We'll get back to you as soon as possible. A confirmation has been sent to your email.",

    // FAQs Page
    "faqsPage.title": "Frequently Asked Questions",
    "faqsPage.subtitle": "Find answers to common questions about our services",

    // Blogs Page
    "blogsPage.title": "Our Blog",
    "blogsPage.subtitle": "Latest news and travel tips",
    "blogsPage.readMore": "Read More",
    "blogsPage.noPosts": "No blog posts available yet.",

    // Testimonials Page
    "testimonialsPage.title": "Customer Reviews",
    "testimonialsPage.subtitle": "See what our customers say about their experience with us",

    // International Page
    "international.title": "International Parking",
    "international.subtitle": "Parking solutions at airports worldwide",
    "international.servicesTitle": "Our Parking Services",
    "international.servicesSubtitle": "Choose the service that best fits your travel needs",
    "international.service.meetGreet.title": "Meet & Greet",
    "international.service.meetGreet.desc":
      "Hand over your car at the terminal, and our professional team will park it securely for you while you travel stress-free.",
    "international.service.parkRide.title": "Park & Ride",
    "international.service.parkRide.desc":
      "Park at our secure lot and enjoy a free shuttle service directly to your terminal—convenient, fast, and hassle-free.",
    "international.service.valet.title": "Valet Parking",
    "international.service.valet.desc":
      "Experience full luxury valet service at the terminal. Hand over your keys and enjoy a seamless, stress-free journey.",

    // Booking Stepper
    "stepper.selectDates": "Select Dates",
    "stepper.chooseParking": "Choose Parking",
    "stepper.yourDetails": "Your Details",
    "stepper.payment": "Payment",

    // Dates Summary
    "datesSummary.title": "Your Trip",
    "datesSummary.entry": "Entry",
    "datesSummary.exit": "Exit",
    "datesSummary.duration": "Duration",
    "datesSummary.days": "days",
    "datesSummary.day": "day",
    "datesSummary.promoCode": "Promo Code",
    "datesSummary.editDates": "Update",

    // Booking Cancelled
    "cancel.title": "Payment not completed",
    "cancel.cancelledDesc": "Your payment was not completed. You can retry the payment or go back to home.",
    "cancel.failedDesc": "Your payment was declined or failed. You can retry the payment or go back to home.",
    "cancel.reference": "Reference:",
    "cancel.retry": "Retry Payment",
    "cancel.home": "Go to Home",

    // Common
    "common.loading": "Loading...",
    "common.error": "An error occurred",
    "common.retry": "Retry",
    "common.cancel": "Cancel",
    "common.confirm": "Confirm",
    "common.save": "Save",
    "common.close": "Close",
    "common.back": "Back",
    "common.next": "Next",
    "common.submit": "Submit",
  },
};

/**
 * Translates dynamic text from API — with Arabic removed, returns text as-is
 */
export const translateDynamicText = (text: string, _language: Language): string => {
  return text;
};

/**
 * Get translation for a static key
 */
export const getTranslation = (key: string, _language: Language): string => {
  return translations.en[key] || key;
};
